import * as Addresses from "./addresses";
import * as ArrestReport from "./arrestReport";
import * as Bio from "./bio";
import * as Businesses from "./businesses";
import * as Charges from "./charges";
import * as CivilPapersCriminalComplaints from "./civilPapersCriminalComplaints";
import * as CivilPapersHearingDates from "./civilPapersHearingDates";
import * as CivilPapersJudgment from "./civilPapersJudgment";
import * as CivilPapersNew from "./civilPapersNew";
import * as CivilPapersPeople from "./civilPapersPeople";
import * as CivilPapersPropertySales from "./civilPapersPropertySales";
import * as Court from "./court";
import * as DataImporter from "./dataImporter";
import * as ProblemFiles from "./problemFiles";
import * as ServiceAttempts from "./serviceAttempts";
import * as ServiceDocuments from "./serviceDocuments";
import * as ServiceTypes from "./serviceTypes";
import * as Transport from "./transport";
import * as TransportsLinkedDocuments from "./transportsLinkedDocuments";
import * as WarrantCharges from "./warrantCharges";
import * as WarrantClearanceInfo from "./warrantClearanceInfo";
import * as WarrantExtraditionInfo from "./warrantExtraditionInfo";
import * as Warrants from "./warrants";
import * as WarrantWaitForInfo from "./warrantWaitForInfo";

export const SCHEMAS = {
  ADDRESSES: Addresses,
  ARREST_REPORT: ArrestReport,
  BIO: Bio,
  BUSINESSES: Businesses,
  CHARGES: Charges,
  CIVIL_PAPERS_CRIMINAL_COMPLAINTS: CivilPapersCriminalComplaints,
  CIVIL_PAPERS_HEARING_DATES: CivilPapersHearingDates,
  CIVIL_PAPERS_JUDGMENT: CivilPapersJudgment,
  CIVIL_PAPERS_NEW: CivilPapersNew,
  CIVIL_PAPERS_PEOPLE: CivilPapersPeople,
  CIVIL_PAPERS_PROPERTY_SALES: CivilPapersPropertySales,
  COURT: Court,
  DATA_IMPORTER: DataImporter,
  PROBLEM_FILES: ProblemFiles,
  SERVICE_ATTEMPTS: ServiceAttempts,
  SERVICE_DOCUMENTS: ServiceDocuments,
  SERVICE_TYPES: ServiceTypes,
  TRANSPORT: Transport,
  TRANSPORTS_LINKED_DOCUMENTS: TransportsLinkedDocuments,
  WARRANT_CHARGES: WarrantCharges,
  WARRANT_CLEARANCE_INFO: WarrantClearanceInfo,
  WARRANT_EXTRADITION_INFO: WarrantExtraditionInfo,
  WARRANT_WAIT_FOR_INFO: WarrantWaitForInfo,
  WARRANTS: Warrants,
};
